import { useLingui } from "@lingui/react/macro";
import { InputForm } from "@silversea-ssc/ui-components-react";
import React from "react";

type Props = {
  className?: string;
  searchUrl?: string;
};

const SearchInput: React.FC<Props> = ({ className, searchUrl }) => {
  const { t } = useLingui();
  return (
    <InputForm
      id="sub-footer-search"
      className={className}
      name="query"
      placeholder={t`Search input placeholder`}
      formAction={searchUrl}
      inputType="search"
      icon="search"
      variant="black"
      buttonVariant="white"
    />
  );
};

export default React.memo(SearchInput);
